import Container from "@/components/common/Container";
import axios from "axios";
import { API_URL, emailValidationRegex } from "const/common";
import { useRouter } from "next/router";
import { useState } from "react";
import { useForm } from "react-hook-form";

function ServicesHeader(data) {
  const { title, paragraph } = data.servicesHeader;
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const router = useRouter();
  const [disabled, setDisabled] = useState(false);

  const onSubmit = (values) => {
    const { name, email, message, phone } = values;
    const formattedMessage = message?.toString().replace(/\r?\n/g, "<br />");
    if (Object.keys(errors).length === 0) {
      setDisabled(true);
      axios
        .post(`${API_URL}admin/contactusdata`, {
          ...values,
          name,
          email,
          phone,
          message: formattedMessage,
          enquiryPage: router.asPath,
        })
        .then(() => {
          reset();
          router.push("/thankyou");
        })
        .finally(() => {
          setDisabled(false);
        });
    }
  };
  return (
    <Container
      large
      className="pt-32 pb-36 xl:pt-56 md:pt-28 md:pb-20 xl:pb-40 bg-header-background bg-center bg-cover bg-no-repeat"
    >
      <div className="flex flex-col lg:flex-row justify-between items-center">
        <div className="lg:w-1/2">
          <h1 className="text-4xl md:text-3xl xl:text-6xl text-white font-medium mb-0 leading-snug xl:leading-tight">
            <span>{title}</span>
          </h1>
          <p className="text-white text-justify text-base md:text-sm xl:text-base font-normal mb-20 pt-9 md:pt-4 md:mb-14 lg:mb-0 xl:pt-8 xl:w-11/12 [&_a]:text-blue-500">
            <span dangerouslySetInnerHTML={{ __html: paragraph }}></span>
          </p>
        </div>
        <div className="w-full lg:w-1/2">
          <div className="bg-black-chocolate max-w-[423px] rounded-lg border border-solid border-primary-yellow py-10 px-8 md:py-14 md:px-10 xl:py-12 mx-auto lg:ml-auto lg:mr-0">
            <div>
              <h2 className="text-primary-yellow text-center text-lg md:text-2xl font-semibold mb-12 md:mb-14">
                <span>Let’s Discuss Your Project</span>
              </h2>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="mb-10 md:mb-6 xl:mb-12">
                  <input
                    className="text-base font-normal p-2 w-full border border-t-0 border-l-0 border-r-0 border-b-white/20 border-solid shadow-none bg-transparent text-white focus:outline-none focus:bg-transparent placeholder:text-white/40"
                    placeholder="Enter Name"
                    {...register("name", { required: true })}
                    autoComplete="off"
                  />
                  {errors.name && (
                    <p className="m-0 ml-2 mt-1 absolute text-red-600">
                      <span>Name is required</span>
                    </p>
                  )}
                </div>
                <div className="mb-10 md:mb-6 xl:mb-12">
                  <input
                    className="text-base font-normal p-2 w-full border border-t-0 border-l-0 border-r-0 border-b-white/20 border-solid shadow-none bg-transparent text-white focus:outline-none focus:bg-transparent placeholder:text-white/40"
                    placeholder="Enter Email ID"
                    type="text"
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value: emailValidationRegex,
                        message: "Enter valid email",
                      },
                    })}
                    autoComplete="off"
                  />
                  {errors.email && (
                    <p className="m-0 ml-2 mt-1 absolute text-red-600">
                      <span>{errors?.email?.message}</span>
                    </p>
                  )}
                </div>
                <div className="mb-10 md:mb-6 xl:mb-12">
                  <input
                    className="text-base font-normal p-2 w-full border border-t-0 border-l-0 border-r-0 border-b-white/20 border-solid shadow-none bg-transparent text-white focus:outline-none focus:bg-transparent placeholder:text-white/40"
                    placeholder="Enter Contact Number"
                    type="number"
                    {...register("phone", {
                      minLength: { value: 6 },
                      maxLength: { value: 15 },
                      pattern: {
                        value: /^\d{6,15}$/,
                        message: "Enter a valid phone number",
                      },
                    })}
                    autoComplete="off"
                  />
                  {errors.phone && (
                    <p className="m-0 ml-2 mt-1 absolute text-red-600">
                      <span>Enter a valid phone number</span>
                    </p>
                  )}
                </div>
                <div>
                  <input
                    className="text-base font-normal p-2 w-full border border-t-0 border-l-0 border-r-0 border-b-white/20 border-solid shadow-none bg-transparent text-white focus:outline-none focus:bg-transparent placeholder:text-white/40"
                    placeholder="Your Message"
                    type="text"
                    {...register("message", { required: true })}
                    autoComplete="off"
                  />
                  {errors.message && (
                    <p className="m-0 ml-2 mt-1 absolute text-red-600">
                      <span>Message is required</span>
                    </p>
                  )}
                </div>
                <button
                  disabled={disabled}
                  className="w-full text-white bg-primary-yellow font-semibold text-base md:text-sm xl:text-lg py-4 px-8 mt-14 md:mt-10 xl:mt-16 border-none rounded-lg"
                  type="submit"
                  onClick={onSubmit}
                >
                  <span>Submit</span>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
}

export default ServicesHeader;
